const firebaseConfig = {

  apiKey: "AIzaSyA32lXpB5KU8UVr2G25HqDMzAtf67xy3yo",

  authDomain: "premier-pottery-retailer.firebaseapp.com",

  projectId: "premier-pottery-retailer",

  storageBucket: "premier-pottery-retailer.appspot.com",

  messagingSenderId: "661126792322",

  appId: "1:661126792322:web:15af354e4e7a41c631609b"

};
export default firebaseConfig;